import { Timeline } from "./Timeline";


/**
 * TimelinePage with metadata context integration
 * This wrapper ensures the Timeline component has access to proper
 * project and story IDs
 */
const TimelinePage = () => {



  // Render the Timeline component with metadata context
  return <Timeline />;
};

export default TimelinePage;